/**
 * @Auther: Qsan
 * @Date：2018年12月14日 21:10
 * @Desc：校验统一配置
 */

const validate = {
    url: {
        pattern: /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/,
        message: '请输入正确的URL'
    },
    email: {
        pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
        message: '请输入正确的邮箱'
    },
    mobile: {
        pattern: /^(13[0-9]|14[0-9]|15[0-3,5-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/,
        message: '请输入正确的手机号'
    }
}

const valid = (pattern, value) => {
    const validObj = validate[pattern] || {}

    if (validObj.pattern) {
        if (typeof validObj.pattern === 'function') {
            if (!validObj.pattern(value)) {
                return false
            }
        } else if (!validObj.pattern.test(value)) {
            return false
        }
    } else if (typeof pattern.test === 'function' && !pattern.test(value)) {
        return false
    }

    return true
}

const validator = (rule, value, callback) => {
    if (value === '') {
        return
    }

    if (!rule.pattern) {
        return callback(new Error('pattern不能为空！'))
    }

    const validObj = validate[rule.pattern] || {}
    const message = rule.message || validObj.message
    if (!validObj.pattern) {
        validObj.pattern = rule.pattern
    }

    if (!valid(validObj.pattern, value)) {
        callback(new Error(message))
    }
    callback()
}

/**
 * 对该表单项进行重置，将其值重置为初始值并移除校验结果
 * @param $form
 */
const resetField = $form => {
    if ($form && $form.resetField) {
        $form.resetField()
    }
}

/**
 * 移除该表单项的校验结果
 * @param $form
 */
const clearValidate = $form => {
    if ($form && $form.clearValidate) {
        $form.clearValidate()
    }
}
/**
 * 判断是否为空
 */
export function validatenull(val) {
    if (val instanceof Array) {
        if (val.length === 0) return true
    } else if (val instanceof Object) {
        if (JSON.stringify(val) === '{}') return true
    } else {
        if (
            val === 'null' ||
            val === null ||
            val === 'undefined' ||
            val === undefined ||
            val === ''
        ) {
            return true
        }
        return false
    }
    return false
}

const install = Vue => {
    Vue.prototype.valid = valid
    Vue.prototype.validate = validate
    Vue.prototype.validator = validator
    Vue.prototype.resetField = resetField
    Vue.prototype.clearValidate = clearValidate
    Vue.prototype.validatenull = validatenull
}

export default {
    install
}



// WEBPACK FOOTER //
// ./src/common/validate.js